import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ChatApiService } from '../../chat/service/chat-api.service';
import { Presentation } from '../model/presentation';

@Injectable({ providedIn: 'root' })
export class PresentationFacadeService {
  private chatApi = inject(ChatApiService);
  public presentation?: Presentation;

  public getPresentation(sessionId: string, id: string): Observable<Presentation> {
    return this.chatApi
      .getPresentation(sessionId, id)
      .pipe(tap((data) => (this.presentation = data)));
  }

  public presentationEnded(sessionId: string, id: string, seconds: number) {
    return this.chatApi.presentationEnded(sessionId, id, seconds);
  }
}
